export default function IconSolidPhoto() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 10"
      id="Image-Picture-Landscape-1--Streamline-Micro"
    >
      <desc>{'Image Picture Landscape 1 Streamline Icon: https://streamlinehq.com'}</desc>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.694 0C0.76 0 0 0.759 0 1.694v6.612C0 9.24 0.759 10 1.694 10h6.612C9.24 10 10 9.241 10 8.306V1.694C10 0.76 9.241 0 8.306 0H1.694ZM7.25 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0 -2.5ZM1.5 8.306v-3.46l0.017 0 0.013 0A4.591 4.591 0 0 1 6.147 8.5H1.694a0.194 0.194 0 0 1 -0.194 -0.194Zm5.657 0.194h1.149a0.194 0.194 0 0 0 0.194 -0.194V5.93a6.085 6.085 0 0 0 -0.752 -0.046 5.961 5.961 0 0 0 -1.607 0.216 5.59 5.59 0 0 1 1.007 2.307c0.006 0.031 0.01 0.062 0.01 0.092Z"
        clipRule="evenodd"
        strokeWidth={1}
      />
    </svg>
  );
}
